import { render, staticRenderFns } from "./SeachDoc.vue?vue&type=template&id=1075c34c&scoped=true"
import script from "./SeachDoc.vue?vue&type=script&lang=js"
export * from "./SeachDoc.vue?vue&type=script&lang=js"
import style0 from "./SeachDoc.vue?vue&type=style&index=0&id=1075c34c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1075c34c",
  null
  
)

export default component.exports